(function(){
  /* Venice Press — Scroll-linked header animation v6.3
     Fix: backdrop/blur now driven by scroll position directly,
     not gated on data-sticky-state. This ensures the frosted
     header appears immediately on page refresh while scrolled. */
  if (window.__vpScrollV6) return;
  window.__vpScrollV6 = true;
  if (window.location.pathname !== '/') return;

  var LOGO_RANGE = 180;
  var LOGO_BIG   = 176;
  var LOGO_SM    = 80;
  var BG_ALPHA   = 0.70;
  var BLUR_MAX   = 12;
  var BG_RANGE   = 150;
  var FADE_START  = 120;
  var FADE_RANGE  = 60;

  var hdr, logos, secs, lnks, logoOrig, logoInv, logoLink;
  var ticking = false, lastT = -1, lastBgT = -1;
  var bound = false;
  var reforcing = false; /* guard against observer infinite loops */

  function forceLayout() {
    if (logoLink) {
      logoLink.style.setProperty('display', 'grid', 'important');
      logoLink.style.setProperty('place-items', 'center', 'important');
      logoLink.style.setProperty('overflow', 'visible', 'important');
    }
    if (logoOrig && logoInv) {
      logoOrig.style.setProperty('grid-area', '1 / 1', 'important');
      logoInv.style.setProperty('grid-area', '1 / 1', 'important');
      logoOrig.style.setProperty('display', 'block', 'important');
      logoInv.style.setProperty('display', 'block', 'important');
    }
    if (hdr) {
      hdr.style.setProperty('--header-logo-display', 'block');
      hdr.style.setProperty('--header-logo-inverse-display', 'block');
    }
  }

  function lerp(a, b, t) { return a + (b - a) * t; }

  /* Full update — applies BOTH layout AND animated sizing/opacity.
     Can be called from scroll handler, observer, or periodic re-force. */
  function update() {
    var sy = window.pageYOffset || document.documentElement.scrollTop;
    var logoT = Math.min(Math.max(sy / LOGO_RANGE, 0), 1);

    /* v6.3 fix: compute background progress directly from scroll position
       instead of gating on data-sticky-state. This ensures the frosted
       backdrop appears immediately even on page refresh while scrolled. */
    var bgT = Math.min(Math.max(sy / BG_RANGE, 0), 1);

    /* Skip only if truly unchanged AND not a forced refresh */
    var forced = (lastT < 0);
    if (!forced && Math.abs(logoT - lastT) < 0.003 && Math.abs(bgT - lastBgT) < 0.003) return;
    lastT = logoT; lastBgT = bgT;

    forceLayout();

    /* Logo size — BOTH height AND width (square 1:1 logo) */
    var h = lerp(LOGO_BIG, LOGO_SM, logoT);
    var hPx = h + 'px';
    for (var i = 0; i < logos.length; i++) {
      logos[i].style.setProperty('height', hPx, 'important');
      logos[i].style.setProperty('max-height', hPx, 'important');
      logos[i].style.setProperty('width', hPx, 'important');
      logos[i].style.setProperty('max-width', hPx, 'important');
      logos[i].style.setProperty('--header-logo-image-height', hPx);
      logos[i].style.setProperty('--header-logo-image-width', hPx);
      logos[i].style.setProperty('--header-logo-image-height-mobile', hPx);
      logos[i].style.setProperty('--header-logo-image-width-mobile', hPx);
    }

    /* Logo crossfade */
    var fadeT = Math.min(Math.max((sy - FADE_START) / FADE_RANGE, 0), 1);
    var whiteOut = Math.min(Math.max((fadeT - 0.7) / 0.3, 0), 1);
    if (logoOrig && logoInv) {
      logoOrig.style.setProperty('opacity', fadeT.toFixed(3), 'important');
      logoInv.style.setProperty('opacity', (1 - whiteOut).toFixed(3), 'important');
    }

    /* Background */
    var alpha = lerp(0, BG_ALPHA, bgT).toFixed(3);
    var bg = 'rgba(253,250,245,' + alpha + ')';
    for (var j = 0; j < secs.length; j++) {
      secs[j].style.setProperty('background', bg, 'important');
      secs[j].style.setProperty('background-color', bg, 'important');
    }

    /* Backdrop blur */
    var blur = 'blur(' + lerp(0, BLUR_MAX, bgT).toFixed(1) + 'px)';
    hdr.style.setProperty('backdrop-filter', blur, 'important');
    hdr.style.setProperty('-webkit-backdrop-filter', blur, 'important');

    /* Nav text color */
    if (fadeT < 0.5) {
      hdr.style.setProperty('color', '#fff', 'important');
      hdr.style.setProperty('--color-foreground', '255 255 255');
      for (var k = 0; k < lnks.length; k++) lnks[k].style.setProperty('color', '#fff', 'important');
    } else {
      hdr.style.removeProperty('color');
      hdr.style.removeProperty('--color-foreground');
      for (var k = 0; k < lnks.length; k++) lnks[k].style.removeProperty('color');
    }
  }

  function init() {
    hdr = document.querySelector('.header-section header-component.header');
    if (!hdr) return false;
    logos = hdr.querySelectorAll('.header-logo__image');
    if (!logos.length) logos = hdr.querySelectorAll('.header-logo img');
    if (!logos.length) return false;
    secs = hdr.querySelectorAll('.header__row .section, .header__row.section');
    if (!secs.length) secs = hdr.querySelectorAll('.section');
    lnks = hdr.querySelectorAll('a, button');
    logoOrig = hdr.querySelector('.header-logo__image-container--original');
    logoInv  = hdr.querySelector('.header-logo__image-container--inverse');
    logoLink = hdr.querySelector('.header-logo');

    /* overflow:visible up the chain */
    hdr.style.setProperty('overflow', 'visible', 'important');
    var rows = hdr.querySelectorAll('.header__row');
    for (var r = 0; r < rows.length; r++) rows[r].style.setProperty('overflow', 'visible', 'important');
    var cols = hdr.querySelectorAll('.header__column');
    for (var c = 0; c < cols.length; c++) cols[c].style.setProperty('overflow', 'visible', 'important');

    /* Initial apply */
    forceLayout();
    update();

    /* ── MutationObserver: watches ALL relevant elements including <img>.
       When the theme JS resets styles, we re-apply everything. ── */
    if (typeof MutationObserver !== 'undefined') {
      var observer = new MutationObserver(function() {
        if (reforcing) return;
        reforcing = true;
        requestAnimationFrame(function() {
          lastT = -1; /* force full re-apply */
          update();
          setTimeout(function() { reforcing = false; }, 50);
        });
      });
      var opts = { attributes: true, attributeFilter: ['style', 'class'] };
      if (logoLink) observer.observe(logoLink, opts);
      if (logoOrig) observer.observe(logoOrig, opts);
      if (logoInv) observer.observe(logoInv, opts);
      observer.observe(hdr, opts);
      /* Watch the actual <img> elements — theme JS resets their sizes */
      for (var i = 0; i < logos.length; i++) {
        observer.observe(logos[i], opts);
      }
    }

    /* ── Periodic re-force for first 5 seconds.
       The theme header.js is a deferred module that may init late.
       This ensures we win the initialization race. ── */
    var forceCount = 0;
    var forceIv = setInterval(function() {
      forceCount++;
      lastT = -1;
      update();
      if (forceCount >= 50) clearInterval(forceIv); /* 50 × 100ms = 5s */
    }, 100);

    return true;
  }

  function onScroll() {
    if (!ticking) { ticking = true; requestAnimationFrame(function() { update(); ticking = false; }); }
  }

  function bind() {
    if (bound) return;
    bound = true;
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  function go() {
    if (init()) { bind(); return; }
    var tries = 0;
    var iv = setInterval(function() {
      tries++;
      if (init()) { clearInterval(iv); bind(); }
      else if (tries > 10) clearInterval(iv);
    }, 300);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', go);
  else go();
})();
